import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeItem, updateItem, generateBill } from '../../Redux/orderSlice';

const CartScreen = () => {
  const cartItems = useSelector(state => state.order.items);
  const dispatch = useDispatch();

  const handleQtyChange = (index, qty) => {
    if (qty < 1) return;
    const updated = { ...cartItems[index], qty };
    dispatch(updateItem({ index, updatedItem: updated }));
  };

  const handleRemove = (index) => {
    dispatch(removeItem(index));
  };

  const totalAmount = cartItems.reduce((sum, item) => sum + item.price * item.qty, 0).toFixed(2);

  const handleBill = () => {
    dispatch(generateBill());
    alert("Bill Generated! Check console.");
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4 text-center">Table Management</h2>

      {/* Tabs */}
      <div className="flex gap-2 overflow-x-auto pb-4">
        {["Default All", "Table 1", "Table 2", "Table 3"].map((label, index) => (
          <button
            key={index}
            className={`px-4 py-2 rounded-full text-sm whitespace-nowrap ${
              index === 1
                ? 'bg-rose-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Cart Items */}
      <div className="space-y-4">
        {cartItems.map((item, i) => (
          <div
            key={i}
            className="flex items-center justify-between p-3 bg-white rounded-xl shadow"
          >
            <div className="flex items-center gap-3">
              <img
                src={item.img}
                alt={item.name}
                className="w-16 h-16 rounded-lg object-cover"
              />
              <div>
                <p className="font-semibold text-gray-800">{item.name}</p>
                <p className="text-xs text-gray-400">(Must choose level)</p>
                <p className="text-rose-600 font-bold">${item.price}</p>
              </div>
            </div>
            <div className="flex flex-col items-end gap-2">
              <div className="bg-rose-600 text-white rounded-full px-3 py-1 text-sm font-bold">
                x{item.qty}
              </div>
              <div className="flex gap-1">
                <button onClick={() => handleQtyChange(i, item.qty + 1)} className="text-xs bg-gray-200 rounded px-2">+</button>
                <button onClick={() => handleQtyChange(i, item.qty - 1)} className="text-xs bg-gray-200 rounded px-2">-</button>
              </div>
              <button onClick={() => handleRemove(i)} className="text-xs text-red-500 underline mt-1">
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>

      {cartItems.length > 0 && (
        <div className="text-center mt-6 space-y-2">
          <p className="text-gray-700 font-medium">
            Total: <span className="text-rose-600 font-bold">${totalAmount}</span>
          </p>
          <button
            onClick={handleBill}
            className="bg-rose-600 text-white px-6 py-2 rounded-full hover:bg-rose-700"
          >
            Generate Bill
          </button>
        </div>
      )}
    </div>
  );
};

export default CartScreen;
